import { User } from "../../models/user";
import { BaseProvider } from "./base.provider";
import { Md5 } from "@gago/solar-terms";
import { BaseRequestServer } from "../servers/base-request.server";
import { getCookie, deleteCookie, setCookie } from "../../utils/common-function";

interface UserListType {
  /** 用户名 */
  username: string;
  /** 密码 */
  password: string;
}
// tslint:disable:no-collapsible-if
/** 检查用户名密码的正确性 */
function judgeUserName(username: string, password: string, userList: UserListType[]) {
  for (const item of userList) {
    if (username === item.username && password === item.password) {
      return true;
    }
  }
  return false;
}
const usersList: UserListType[] = window.config.users;
/**
 * 用户授权接口
 *
 * @author 张卓诚
 * @date 2018-12-29
 * @export
 * @class UserProvider
 * @extends {BaseProvider<User>}
 */
export class UserProvider extends BaseProvider<User> {
  /** 服务器1 */
  server = new BaseRequestServer();
  /** 用户名列表数据 */
  /**
   * 登陆
   *
   * @author 张卓诚
   * @date 2018-12-29
   * @param {string} 用户名
   * @param {string} 密码明文
   * @returns
   * @memberof UserProvider
   */
  async login(username: string, password: string) {
    const passw = Md5.hex_hmac_md5("jiaji", password);
    const userExist = judgeUserName(username, passw, usersList);
    if (userExist) {
      setCookie("NAME", username, 7);
      setCookie("PASSWORD", passw, 7);
      return { name: username };
    }
    return { error: "用户名密码错误！" };
  }

  /**
   * 模拟登陆
   *
   * @author 张卓诚
   * @date 2018-12-29
   * @param {string} username
   * @param {string} password
   * @returns
   * @memberof UserProvider
   */
  async mockLogin(username: string, password: string) {
    return { name: username };
  }

  /**
   * 模拟检测登陆状态
   * @author 张卓诚
   * @date 2018-12-29
   * @param {string} username
   * @param {string} password
   * @returns
   * @memberof UserProvider
   */
  async checkLogin() {
    // const username = getCookie("NAME");
    // const passw = getCookie("PASSWORD");
     const username = "admin";
    const passw = "b0d2a84890b01641358daae6f7fa9870";
    if (username && passw) {
      const userExist = judgeUserName(username, passw, usersList);
      if (userExist) {
        return { name: username };
      }
    }
    throw new Error(("未检测出登录"));
  }

  /**
   * 登出
   *
   * @author 张卓诚
   * @date 2018-12-29
   * @returns
   * @memberof UserProvider
   */
  async logout() {
    deleteCookie("NAME");
    deleteCookie("PASSWORD");
    return {};
  }
}

export default new UserProvider();
